const Form = () => import('@/views/form/form')
export default {
  path: '/form/:type',
  name: 'form',
  component: Form,
  meta: {
    auth: true,
    title: '用户信息修改',
    noHeader: true
  }
}
